
export const getSessionIdFromFixCfg = (session) =>
    `${session.senderCompID}:${session.targetCompID}${session.senderSubID ? `:${session.senderSubID}` : ''}${
        session.targetSubID ? `:${session.targetSubID}` : ''
    }`

export const getSessionIdFromSessionIdObject = (sessionId) =>
    `${sessionId.localCompID}:${sessionId.remoteCompID}${sessionId.localSubID ? `:${sessionId.localSubID}` : ''}${
        sessionId.remoteSubID ? `:${sessionId.remoteSubID}` : ''
    }`


export const isRouterSession = (session, config) => config.router && isRouterMessageParser(session.messageParser, config.router['@UiRouterCfg'].messageParser)
export const isRouterMessageParser = (messageParser, routerMessageParserClass) => (messageParser && messageParser.hasOwnProperty(`@${routerMessageParserClass}`))
export const isDownstreamSession = (session) => (session.routingDestination)